import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Customer } from '@digital-platform/customers/domain';

interface Response<T> {
  customers: T[];
}

@Injectable({
  providedIn: 'root'
})
export class CustomersService {
  constructor(private httpClient: HttpClient) {}

  public getCustomers(): Observable<Customer[]> {
    return this.httpClient
      .get<Response<Customer>>('/api/customers')
      .pipe(map(response => response.customers));
  }
}
